import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { tokenResponse } from "../models";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthService {
  constructor(private http: HttpClient) {}

  public loginWithCF() {
    const cookies = document.cookie.split(';').reduce((res, c) => {
      const [key, val] = c.trim().split('=').map(decodeURIComponent)
      try {
        return Object.assign(res, { [key]: JSON.parse(val) })
      } catch (e) {
        return Object.assign(res, { [key]: val })
      }
    }, {});
    return this.http.post<tokenResponse>(`${environment.apiEndpoint}/api/validate-cf-token`, {
      token: cookies['CF_Authorization'] || null
    });
  }

  static jwtDecode(jwt: string) {
    const tokens = jwt.split(".");
    return JSON.parse(atob(tokens[1]));
  }
}
